
























































































import { Component, Vue } from 'vue-property-decorator';
import { newDedicatedMachineService } from '@/components/new-dedicated-machine/services/NewDedicatedMachineService';
import { pricesService } from '@/services/PricesService';
import PriceWithCurrency from '@/components/common/PriceWithCurrency.vue';
import TooltipBox from '@/components/common/TooltipBox.vue';
import { mapState } from 'vuex';

@Component({
  components: {
    PriceWithCurrency,
    TooltipBox,
  },
  computed: {
    ...mapState({
      userRole: (state: any) => state.currentWorkspace.role,
      workspaceData: (state: any) =>
        state.workspaces.workspaces.find(
          (item: any) => parseInt(item.id, 10) === parseInt(state.currentWorkspace.id, 10)
        ) || {},
    }),
  },
})
export default class DedicatedMachineDetails extends Vue {
  workspaceId: number = 0;
  regionId: number = 0;
  dedicatedMachines: any = [];
  priceModifier: number = 0.00001;
  hoursInMonth: number = 730;
  availableUnits: any = [];

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    this.getDedicatedMachines();
  }
  getDedicatedMachines() {
    newDedicatedMachineService
      .getNewDedicatedMachineData(this.workspaceId, this.regionId)
      .then(data => {
        this.dedicatedMachines = data;
        this.availableUnits = data.available_units;
        this.getPrices();
      })
      .catch(() => {});
  }
  getPrices() {
    pricesService.getPrices(this.workspaceId, this.regionId).then((data: any) => {
      this.dedicatedMachines = this.dedicatedMachines.map((item: any) => {
        item.price = data.find((resource: any) => item.resource === resource.resource);
        return item;
      });
    });
  }
  selectDedicatedMachine(selectedId: number) {
    this.$router
      .push(`/workspaces/${this.workspaceId}/regions/${this.regionId}/dedicated-machines/${selectedId}`)
      .catch(() => {});
  }
}
